package com.merkost.handpass.api.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class ProfileVisibility(val value: String) {
    @SerialName("public") PUBLIC("public"),
    @SerialName("private") PRIVATE("private");

    companion object {
        fun fromString(value: String): ProfileVisibility =
            entries.find { it.value == value.lowercase() } ?: PUBLIC

        fun fromDbValue(value: String): ProfileVisibility = fromString(value)
    }
}
